import {
  HStack,
  Icon,
  ICON_SIZES,
  IconName,
  MixpanelEvent,
  Popover,
  PowerSearchShortcut,
  useMixpanel,
  usePopoverState,
  usePowerSearchContext,
} from '@talos/kyoko';
import type { CSSProperties } from 'react';
import { useCallback } from 'react';
import { SidebarItemWrapper } from './styles';

const SIDEBAR_ITEM_TARGET_STYLE: CSSProperties = {
  pointerEvents: 'none',
};

export function SidebarSearchItem() {
  const mixpanel = useMixpanel();
  const popover = usePopoverState({ trigger: 'hover', placement: 'right', usePortal: true, delay: 200 });
  const {
    modal: { open },
  } = usePowerSearchContext();
  const handleOpenPowerSearch = useCallback(() => {
    popover.close();
    mixpanel.track(MixpanelEvent.OpenPowerSearch);
    open();
  }, [mixpanel, open, popover]);

  return (
    <Popover {...popover} isSmall contentStyle={SIDEBAR_ITEM_TARGET_STYLE}>
      <SidebarItemWrapper as="button" data-testid="sidebar-search-item" onClick={handleOpenPowerSearch}>
        <Icon icon={IconName.Search} size={ICON_SIZES.MEDIUM} />
      </SidebarItemWrapper>
      <HStack gap="spacing2">
        Power Search
        <PowerSearchShortcut />
      </HStack>
    </Popover>
  );
}
